import { render, staticRenderFns } from "./talentCode.vue?vue&type=template&id=ba6779be&scoped=true&"
import script from "./talentCode.vue?vue&type=script&lang=js&"
export * from "./talentCode.vue?vue&type=script&lang=js&"
import style0 from "./talentCode.vue?vue&type=style&index=0&id=ba6779be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6779be",
  null
  
)

export default component.exports